import { wikiToPlainText } from '@/util/tokenize_wiki_text'

export interface GoalSection {
  key: string
  label: string
  text: string
  group?: string
}

export type GoalSectionsLayout = 'stacked' | 'rows'

export interface GoalFormat {
  layout?: GoalSectionsLayout
  [field: string]: unknown
}

const DEFAULT_GOAL_SECTIONS_LAYOUT: GoalSectionsLayout = 'stacked'

/** Vue 2's hint on saved goal text the viewer may not edit. */
export const COPY_TO_EDIT_HINT = 'To make edits, copy this page to your own Library.'

export function composeGoalText(sections: GoalSection[]): string {
  return sections.map(({ label, text }) => `**${label}**\n\n${text}`).join('\n\n')
}

export function goalSectionsPlainText(sections: GoalSection[]): string {
  return sections.map(({ label, text }) => `${label}\n${wikiToPlainText(text)}`).join('\n\n')
}

export function groupSentences(sections: GoalSection[]): { label: string, text: string }[] {
  const textsByGroup = new Map<string, string[]>()
  sections.forEach(({ group, text }) => {
    if (group) textsByGroup.set(group, [...(textsByGroup.get(group) ?? []), wikiToPlainText(text)])
  })
  return [...textsByGroup].map(([label, texts]) => ({ label, text: texts.join(' ') }))
}

export function goalSectionsLayout(format: GoalFormat | null | undefined): GoalSectionsLayout {
  return format?.layout || DEFAULT_GOAL_SECTIONS_LAYOUT
}

export function goalSectionsPayload(sections: GoalSection[] | null | undefined, format: GoalFormat | null | undefined) {
  return sections ? { goal_sections: sections, goal_format: format } : {}
}

export function replaceSectionText(sections: GoalSection[], key: string, text: string): GoalSection[] {
  return sections.map((section) => (section.key === key ? { ...section, text } : section))
}
